// Cross-matter signals: the rules-based interactions the server detects
// across one client's matters (crimmigration, deadline stacks, ...).
// Renders nothing when there are none. Signals carry Mongo _ids, not
// eIds, so no matter links here - by-eid would 404 on them.

import { SEP } from "../chrome/SepList";
import type { ClientIntelSignal } from "../../api/mock";
import { useClientIntelligence } from "../../hooks/useClientIntelligence";

// Exhaustive over the contract union - a new severity is a build error
// here, not a silently muted signal.
const SEVERITY_TONE: Record<ClientIntelSignal["severity"], string> = {
  critical: "var(--red-700)",
  warning: "var(--warn-600)",
  info: "var(--muted)",
};

export function ClientSignals({ clientId }: { clientId: string }) {
  const { data: signals = [] } = useClientIntelligence(clientId);
  if (signals.length === 0) return null;

  return (
    <div className="cc-card" style={{ marginTop: 14 }}>
      <div className="cc-card-head">
        <div className="cc-card-title">Cross-matter signals</div>
        <div className="cc-card-sub">
          {SEP}
          {signals.length}
        </div>
      </div>
      <div>
        {signals.map((s, i) => (
          // Inline row styling: the .row selectors are scoped under
          // .client-tab-body and this card sits above the tabs
          // (precedent: JudgeDetail's card rows).
          <div
            key={s.id}
            style={{
              padding: "12px 18px",
              borderTop: i > 0 ? "1px solid var(--line-2)" : "none",
            }}
          >
            <div style={{ fontSize: 13, fontWeight: 550, color: "var(--ink)" }}>
              {s.title}
              <span
                style={{
                  color: SEVERITY_TONE[s.severity],
                  marginLeft: 8,
                  fontSize: 11,
                  textTransform: "uppercase",
                  letterSpacing: "0.08em",
                }}
              >
                {s.severity}
              </span>
            </div>
            <div style={{ fontSize: 11, color: "var(--muted)", marginTop: 2 }}>{s.explanation}</div>
            {s.suggestedAction && (
              <div style={{ fontSize: 11, color: "var(--ink-2)", marginTop: 2 }}>
                {"-> " + s.suggestedAction}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
